/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { Button } from '@mui/material';
import * as React from 'react';
import Dropzone from 'react-dropzone';;
import { base64ToBlob } from '../common/common';
import './styles.css';
interface Props {
    onDrop: Function
    selectedPdf: any
    fileName: any
    fileType: any
    fileSize: any
}
interface State {
    selectedPdf: any
    fileType: any
    fileName: any
    fileSize: any
    error: any
    isEdit: any
}
class DragDropDownloads extends React.Component<Props, State>{
    state = {
        selectedPdf: undefined,
        fileType: undefined,
        fileName: undefined,
        fileSize: undefined,
        error: undefined,
        isEdit: false
    };
    componentDidMount() {
        if (this.props.selectedPdf !== undefined) {
            this.setState({ selectedPdf: this.props.selectedPdf instanceof Blob ? URL.createObjectURL(this.props.selectedPdf) : this.props.selectedPdf });
            this.setState({ isEdit: this.props.selectedPdf ? true : false });
            this.setState({ fileName: this.props.fileName });
            this.setState({ fileSize: this.props.fileSize });
            if (this.props.fileType === undefined) {
                const filename = this.props.fileName.split('.');
                const type = filename[filename.length - 1];
                if (type === 'png' || type === 'jpeg') {
                    this.setState({ fileType: 'image/' + type });
                }
                else {
                    this.setState({ fileType: 'application/' + type });
                }
            }
            else {
                this.setState({ fileType: this.props.fileType });
            }
        }
    }
    onDrop = (files: any) => {
        this.setState({ error: undefined });
        if (files.length) {
            const currentFile = files[0];
            const reader = new FileReader();
            let a: any = undefined;
            reader.addEventListener('load', () => {
                a = reader.result;
                if (a != null) {
                    const b = a.split(',')[1];
                    const blob = base64ToBlob(b, currentFile.type);
                    const url = URL.createObjectURL(blob);
                    this.setState({ selectedPdf: url }, () => {
                        this.props.onDrop(blob, currentFile.name, currentFile.type, currentFile.size / 1024);
                    });
                    this.setState({ fileType: currentFile.type });
                    this.setState({ fileName: currentFile.name });
                    this.setState({ fileSize: currentFile.size / 1024 });
                }
            }, false);
            reader.readAsDataURL(currentFile);
        }
    };

    onDropRejected = (error: any) => {
        const errorMessage = error[0].errors[0].message;
        this.setState({ error: errorMessage });
    };

    render() {
        const { selectedPdf, fileType, fileName, fileSize, error, isEdit } = this.state;
        return (
            !isEdit ?
                (selectedPdf === undefined) ?
                    <div className="text-center dropZone">
                        <p className="redColor">{error}</p>
                        <Dropzone onDrop={this.onDrop} accept={{ 'application/pdf': ['.pdf'], 'image/jpeg': ['.jpg', '.jpeg'], 'image/png': ['.png'], 'application/zip': ['.zip'], 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'], 'text/plain': ['.txt', '.cfg'], 'application/octet-stream': ['.cfg'] }}
                            maxSize={150000000}
                            onDropRejected={this.onDropRejected}                    >
                            {({ getRootProps, getInputProps }) => (
                                <div {...getRootProps()}>
                                    <input {...getInputProps()} />

                                    <div>
                                        <p> Drag & Drop file here </p>
                                        <p>(or)</p>
                                        <Button className="uploadFromComputer">Upload from computer</Button>
                                    </div>
                                </div>
                            )}
                        </Dropzone>
                    </div>
                    :
                    (fileType === 'image/jpeg' || fileType === 'image/png') ?
                        <div> <img src={selectedPdf} alt={fileType} className="dragDropPdfBox" /> </div>
                        :
                        (fileType === 'application/pdf') ?
                            <object data={selectedPdf} type="application/pdf" className="dragDropPdfBox"> <embed src={selectedPdf} type="application/pdf" /> </object>
                            :
                            <div className="text-center dropZone">
                                <p>{fileName}({fileSize} KB) has been uploaded</p>
                            </div>
                :
                (fileType === 'image/jpeg' || fileType === 'image/png') ?
                    <div> <img src={selectedPdf} alt={fileType} className="dragDropPdfBox" /> </div>
                    :
                    (fileType === 'application/pdf') ?
                        <object data={selectedPdf} type="application/pdf" className="dragDropPdfBox"> <embed src={selectedPdf} type="application/pdf" /> </object>
                        :
                        <div className="text-center dropZone">
                            <p>{fileName} {fileSize === '' ? ` ${fileSize}KB` : ''} has been uploaded</p>
                        </div>
        );
    }
}

export default DragDropDownloads;
